import * as agreementApi from '@authoringPlatform/../api/agreement';
import * as authorApi from '@authoringPlatform/../api/authors';
import Vue from 'vue';

const getDefaultState = () => ({
  authenticated: false,
  isAdmin: false,
  loginCt: null,
  firstName: '',
  lastName: '',
  username: '',
  email: '',
  company: '',
  companyType: '',
  jobTitle: '',
  isAgreed: false,
  actorKey: null,
  playOnboard: null,
  professorKey: null,
});

export default {
  namespaced: true,

  state: getDefaultState(),

  actions: {
    login: async ({ commit }, { username, password }) => {
      const userInfo = await authorApi.login({ username, password });

      commit('AUTHENTICATE_USER', userInfo);
    },
    agreeToTos: async ({ commit }, payload) => {
      try {
        const { isAgreed } = await agreementApi.updateAgreement(payload);
        commit('SET_USER_AGREED', { isAgreed });
      } catch (e) {
        commit('SET_ALERT', 'There was a problem while updating user agreement', { root: true });
      }
    },
    signOut: async ({ commit }) => {
      try {
        commit('SIGN_OUT');
        // TODO: Should we pass userkey param in?
        await authorApi.logout();
      } catch (e) {
        commit('SET_ALERT', null, { root: true });
      }
    },
    deleteAccount: async ({ commit }) => {
      try {
        // TODO: Should we pass userkey param in?
        await authorApi.updateIsDeleted();
        commit('SIGN_OUT');
      } catch (e) {
        commit('SET_ALERT', 'There was a problem while deleting your account', { root: true });
      }
    },
    disableOnboardVid: async ({ commit }) => {
      commit('SET_ONBOARD_VID_PLAY_STATUS', false);
    },
    enableOnboardVid: async ({ commit }) => {
      commit('SET_ONBOARD_VID_PLAY_STATUS', true);
    },
  },

  mutations: {
    AUTHENTICATE_USER: (state, userInfo) => {
      state.authenticated = true;

      Object.entries(userInfo).forEach(([userAttr, attrVal]) => (state[userAttr] = attrVal));
    },
    SIGN_OUT: (state) => {
      Object.assign(state, getDefaultState());
    },
    SET_ONBOARD_VID_PLAY_STATUS: (state, status) => {
      Vue.set(state, 'playOnboard', status);
    },
    SET_USER_AGREED: (state, { isAgreed }) => {
      state.isAgreed = isAgreed;
    },
  },
};
